// Behaviour type → component whose variants.jsx (and CMS StyleVariant collections) style it
const BEHAVIOR_VARIANT_COMPONENT = {
    Text: 'Typography',
    Button: 'Button',
    Input: 'Input',
    Image: 'Image',
};

export const behaviorVariantComponent = (type) => {
    if (!type) return null;
    if (BEHAVIOR_VARIANT_COMPONENT[type]) return BEHAVIOR_VARIANT_COMPONENT[type];
    // AldooButton → Button, AldooDropdownSelect → DropdownSelect, ...
    if (type.startsWith('Aldoo')) return type.slice('Aldoo'.length);
    return null;
};

/**
 * The attached Aldoo-RA behaviour that should receive the node's variant string
 * as its own `variant` prop (instead of the classes going on the node wrapper).
 * Text/Typography styles stay on the wrapper.
 */
export const findVariantBehavior = (behaviors, variantComponent) => {
    if (!variantComponent || variantComponent === 'Typography') return null;
    return (behaviors || []).find(c =>
        c.type !== 'Text' && behaviorVariantComponent(c.type) === variantComponent
    ) || null;
};
